import { ProviderToken } from '@angular/core';
import { ErrorCode } from './interface/http-response.interface';
import { BaseErrorHandlerModel } from './interface/error-handler.interface';
import { BadRequestErrorHandlerService } from './services/error-handlers/bad-request-error-handler.service';
import { NotFoundErrorHandlerService } from './services/error-handlers/not-found-error-handler.service';
import { ConflictErrorHandlerService } from './services/error-handlers/conflict-error-handler.service';
import { ServerErrorHandlerService } from './services/error-handlers/server-error-handler.service';
import { DefaultErrorHandlerService } from './services/error-handlers/default-error-handler.service';
import { ProgressEventHandlerService } from './services/error-handlers/progress-event-handler.service';

// This constant maps error codes to their respective error handler services.
// It uses a Record type to ensure that all error codes are accounted for, and provides a default handler for any unspecified codes.
export const ErrorResponseHandlerMapConstant: Record<ErrorCode, ProviderToken<BaseErrorHandlerModel>> = {
    [ErrorCode.BadRequest]: BadRequestErrorHandlerService,
    [ErrorCode.NotFound]: NotFoundErrorHandlerService,
    [ErrorCode.Conflict]: ConflictErrorHandlerService,
    [ErrorCode.Gone]: ConflictErrorHandlerService,
    [ErrorCode.InternalServerError]: ServerErrorHandlerService,
    [ErrorCode.NotImplemented]: ServerErrorHandlerService,
    [ErrorCode.BadGateway]: ServerErrorHandlerService,
    [ErrorCode.ServiceUnavailable]: ServerErrorHandlerService,
    [ErrorCode.GatewayTimeout]: ServerErrorHandlerService,
    [ErrorCode.ProgressEvent]: ProgressEventHandlerService,
    [ErrorCode.Default]: DefaultErrorHandlerService,
};
